export enum FilterTypes {
  CROPS,
  CATEGORY,
  BRANDS,
}
